<template>
  <div :id="`iframe.wrapper.${keyId}`" class="r1_iframe_embed">
    <v-progress-circular v-if="loading" class="iframe_loader" color="primary" indeterminate size="35" width="5"/>
  </div>
</template>

<script>
export default {
  name: "videoIframe",

  props: {
    video: Object,
    keyId: Number
  },

  data: () => ({
    loading: false,
  }),

  created() {
    this.loading = true;
    this.setMediaElement();
  },

  methods: {
    isDirectVideo(url) {
      if (!url) return false;
      return url.toLowerCase().match(/\.(mp4|webm|ogg)$/) !== null;
    },

    setMediaElement() {
      const url = this.video.url || this.video.file_link;
      const isDirect = this.isDirectVideo(url);
      
      let mediaElement;

      if (isDirect) {
        mediaElement = document.createElement("video");
        mediaElement.controls = true;
        mediaElement.style.display = "none";
        mediaElement.style.width = "100%";
        mediaElement.style.height = "100%";
        mediaElement.style.objectFit = "contain";
        mediaElement.style.borderRadius = "8px";
      } 
      else {
        mediaElement = document.createElement("iframe");
        mediaElement.style.display = "none";
        mediaElement.style.border = '0 #ffffff none';
        mediaElement.name = this.video.name || this.video.title || "video";
        mediaElement.allow = "accelerometer; encrypted-media; gyroscope; picture-in-picture";
        mediaElement.allowFullscreen = true;
      }

      this.$nextTick(() => {
        const holder = document.getElementById(`iframe.wrapper.${this.keyId}`);
        if (holder) {
          holder.appendChild(mediaElement);

          mediaElement.src = url;          
          const eventName = isDirect ? "loadeddata" : "load";
          
          mediaElement.addEventListener(eventName, function (event) {
            this.loading = false;
            event.target.style.display = "";
          }.bind(this));
          
          if (isDirect) {
            mediaElement.addEventListener("error", function () {
              this.loading = false;
            }.bind(this));
          }
        }
      });
    }
  }
}
</script>

<style scoped>
.r1_iframe_embed {
  position: relative;
  overflow: hidden;
  width: 300px;
  height: 170px;
  background-color: #000; 
  border-radius: 8px;
}

.r1_iframe_embed >>> iframe,
.r1_iframe_embed >>> video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.r1_iframe_embed >>> .iframe_loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
